// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.065);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pending {
  background-color: var(--ion-color-warning);
  background-size: 26.39px 24.61px;
}

.accepted {
  background-color: var(--ion-color-success);
}

.declined {
  background-color: #ed143d;
}

.resourceless {
  background-color: #0078d4 !important;
}

ion-card {
  margin: 20px 10px;
}
ion-card .image-swiper-container {
  --swiper-pagination-color: #ed143d;
  width: 100%;
  overflow: hidden;
  height: 0;
  transition: height 0.3s ease-in-out;
}
ion-card .image-swiper-container.show {
  height: 280px;
}
ion-card .image-swiper-container swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100% !important;
}
ion-card .image-swiper-container swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
ion-card .div-horizental {
  width: 6px;
  min-width: 6px;
  height: 100%;
  z-index: 10;
}
ion-card:first-child {
  margin: 10px 10px 20px;
}
ion-card .wrapper {
  width: 100%;
}
ion-card ion-item::part(native) {
  --inner-padding-end: 0px;
  --padding-start: 0;
}
ion-card .new-event-icon {
  position: absolute;
  color: orange;
  top: 5px;
  font-size: 13px;
  right: 5px;
  z-index: 3;
}
ion-card ion-card-header {
  padding: 10px 10px 0 0px;
  margin-left: 10px;
}
ion-card ion-card-header ion-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  justify-content: center;
}
ion-card ion-card-header ion-card-title ion-thumbnail {
  margin-bottom: 5px;
}
ion-card ion-card-header ion-card-title ion-thumbnail ion-avatar {
  margin: 0 auto;
}
ion-card ion-card-header ion-card-title ion-label {
  font-size: 20px;
  flex-grow: 3;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card ion-card-header ion-card-title .operation-buttons-container {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 26px;
  transform: translateY(-5px);
}
ion-card ion-card-header ion-card-title .operation-buttons-container ion-icon[name=arrow-redo-outline] {
  font-size: 24px;
  color: var(--ion-color-primary);
  margin-left: 8px;
}
ion-card ion-card-header ion-card-subtitle {
  padding-bottom: 5px;
  display: flex;
  font-size: 11px;
  align-items: center;
  margin-right: 5px;
}
ion-card ion-card-header ion-card-subtitle .location-icon {
  margin-right: 2.5px;
}
ion-card ion-card-content {
  margin-left: 10px;
  padding: 0px;
}
ion-card ion-card-content .chips-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 8px;
  padding-right: 8px;
}
ion-card ion-card-content .event-detail {
  display: flex;
  gap: 3px;
  align-items: center;
  font-size: 13px;
  padding: 2px 5px;
}
ion-card ion-card-content .event-detail ion-icon {
  font-size: 20px;
  margin-right: 5px;
}
ion-card ion-card-content ion-chip {
  padding-inline: 10px;
  font-size: 11px;
}
ion-card ion-card-content ion-chip ion-icon {
  margin-right: 3.5px;
}
ion-card ion-card-content ion-chip.organizer-chip img {
  margin-right: 3.5px;
}
ion-card ion-card-content .check-in-section {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;
}
ion-card ion-card-content .check-in-section .check-in-button {
  width: 158px;
  height: 36px;
  margin-bottom: 0;
  margin-right: -1px;
  text-transform: none;
  cursor: pointer;
}
ion-card ion-card-content .check-in-section .check-in-button .content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: white;
}
ion-card ion-card-content .check-in-section .check-in-button::part(native) {
  border-radius: 0;
  border-top-left-radius: 18px;
  box-shadow: 0px 0px 0px 8px rgba(0, 0, 0, 0.075);
}
ion-card ion-card-content .custom-red-button {
  --background: #ed143d;
  --background-hover: #d91237;
  --background-activated: #c01031;
  --background-focused: #d91237;
  --color: #ffffff;
  --ripple-color: rgba(255, 255, 255, 0.35);
  text-transform: none;
}
ion-card ion-card-content .description-section {
  padding-bottom: 8px;
  border-top: 1px solid #e0e0e0;
  margin-top: 5px;
}
ion-card ion-card-content .description-section .description-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
ion-card ion-card-content .description-section .description-content.expanded {
  height: auto;
  overflow-y: auto;
  max-height: 250px;
}
ion-card ion-card-content .description-section .description-content .segment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
  padding: 5px;
}
ion-card ion-card-content .description-section .description-content .segment-header ion-segment {
  --background: none;
  display: flex;
  justify-content: start;
  gap: 5px;
  flex: 1;
}
ion-card ion-card-content .description-section .description-content .segment-header ion-segment ion-segment-button {
  --indicator-box-shadow: none;
  --color-checked: #ed143d;
  --border-radius: none;
  --border-width: 0;
  --border-color: none;
  --border-style: none;
  --padding-start: 5px;
  --padding-end: 5px;
  min-width: unset;
}
ion-card ion-card-content .description-section .description-content .segment-header ion-segment ion-segment-button.selectedSegment {
  border-bottom: 2px solid #ed143d;
}
ion-card ion-card-content .description-section .description-content .segment-header .expand-icon {
  font-size: 20px;
  cursor: pointer;
  color: #b0b0b0;
  margin-left: 10px;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
ion-card ion-card-content .description-section .description-content .segment-content-container {
  padding: 5px;
  overflow: auto;
}
ion-card ion-card-content .description-section .description-content .segment-content-container ion-spinner {
  display: block;
  margin: 0 auto;
}
ion-card ion-card-content .description-section .description-content .segment-content-container .attachment-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 0;
  border-bottom: 1px solid #e0e0e0;
}
ion-card ion-card-content .description-section .description-content .segment-content-container .attachment-item ion-img {
  width: 30px;
  height: 30px;
  border-radius: 5px;
}
ion-card ion-card-content .description-section .description-content .segment-content-container .attachment-item .attachment-name {
  font-size: 12px;
  font-weight: 600;
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
ion-card ion-card-content .description-section .description-content .segment-content-container .attachment-item .attachment-size {
  font-size: 12px;
  color: #6e6e6e;
}
ion-card ion-card-content .description-section .description-content .segment-content-container .attachment-item .download-button {
  --padding-start: 4px;
  --padding-end: 4px;
  --min-height: 24px;
  --min-width: 24px;
  margin: 0;
}
ion-card ion-card-content .description-section .description-content .segment-content-container .attachment-item .download-button ion-icon {
  font-size: 16px;
  color: #ed143d;
}
ion-card ion-card-content .description-section .description-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 5px;
}
ion-card ion-item-options .myBookings-sliding-options {
  margin: 1px;
  color: black;
  border-radius: 10px;
  font-size: 12px;
  padding: 0 7px;
}
ion-card ion-item-options .myBookings-sliding-options ion-icon {
  font-size: 24px;
}

ion-popover {
  --max-height: 40vh;
  --min-width: 240px;
}

ion-popover.seriesPopOver::part(content) {
  left: 5%;
}

ion-popover.seriesPopOver {
  --width: 90%;
  --min-height: 0;
}

ion-popover.ResponsePopOver {
  --min-width: fit-content;
}

ion-popover.info-popover::part(content) {
  min-width: unset;
  width: -webkit-fit-content;
  width: fit-content;
}

ion-popover.resource-images-popover {
  --height: unset;
  --max-height: unset;
  --width: 420px;
}
ion-popover.resource-images-popover::part(content) {
  padding: 7px;
}
ion-popover.resource-images-popover .image-swiper-container {
  --swiper-pagination-color: #ed143d;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}
ion-popover.resource-images-popover .image-swiper-container swiper-slide .image-container {
  width: 100%;
  height: 280px;
  overflow: hidden;
}
ion-popover.resource-images-popover .image-swiper-container swiper-slide .image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
ion-popover.resource-images-popover .resource-images-info {
  padding-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
ion-popover.resource-images-popover .resource-images-info ion-label {
  font-weight: 600;
}
ion-popover.resource-images-popover .resource-images-info ion-icon {
  font-size: 16px;
  color: #ed143d;
}
ion-popover.resource-images-popover .resource-images-info ion-chip {
  cursor: default;
}

ion-popover.display-name {
  --width: 275px;
}
ion-popover.display-name ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label {
  margin: 5px 10px;
}
ion-popover.display-name ion-label .displayName,
ion-popover.display-name ion-label .address,
ion-popover.display-name ion-label .emailAddress {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 7px 0;
  word-break: break-word;
}
ion-popover.display-name ion-label .displayName div,
ion-popover.display-name ion-label .address div,
ion-popover.display-name ion-label .emailAddress div {
  display: flex;
}
ion-popover.display-name ion-label .address {
  font-size: 12px !important;
}
ion-popover.display-name ion-label .address ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label .displayName {
  font-size: 15px;
}
ion-popover.display-name ion-label .emailAddress ion-icon {
  color: #6e6e6e;
}
ion-popover.display-name ion-label .emailAddress small {
  color: #6e6e6e;
  font-size: 12px;
  font-weight: 500;
}

ion-popover.extend-meeting-popover {
  --width: 325px;
  --height: unset;
}
ion-popover.extend-meeting-popover .extend-meeting-container {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
ion-popover.extend-meeting-popover .title-label {
  text-align: center;
  font-weight: 600;
}
ion-popover.extend-meeting-popover .extend-meeting-options {
  margin: 0 auto;
}
ion-popover.extend-meeting-popover .extend-meeting-options ion-chip {
  padding: 4px 8px;
  min-height: unset;
}
ion-popover.extend-meeting-popover .extend-meeting-error-note {
  text-align: center;
  font-size: 12px;
  color: #ed143d !important;
}

.container {
  font-size: 14px;
  max-height: 250px !important;
  margin: 8px 5px 8px 13px;
  overflow-y: scroll;
}
.container ion-item {
  font-size: 12px;
}
.container ion-item ion-icon {
  font-size: 30px;
  margin-right: 5px;
}
.container::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.container::-webkit-scrollbar-track {
  background: transparent;
}
.container::-webkit-scrollbar-thumb {
  background: var(--ion-color-light);
  border-radius: 2px;
}
.container .inner-scroll {
  scrollbar-width: thin;
}

.tip-container {
  margin: 8px 13px 8px 13px;
  font-size: 14px;
}

.user-response-container ion-icon {
  font-size: 30px;
}

ion-popover.forward-options {
  --min-width: unset !important;
}
ion-popover.forward-options ion-item {
  font-size: 14px;
}
ion-popover.forward-options ion-item ion-icon {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/my-bookings-item-legacy/my-bookings-item-legacy.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEE;EACE,0CAAA;EACA,gCAAA;AACJ;;AAGE;EAEE,0CAAA;AADJ;;AAIE;EAEE,yBAAA;AAFJ;;AAKE;EACE,oCAAA;AAFJ;;AAKE;EAmCE,iBAAA;AApCJ;AAEI;EACE,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,mCAAA;AAAN;AAEM;EACE,aAAA;AAAR;AAGM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AADR;AAGQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADV;AAKI;EACE,UAAA;EACA,cAAA;EAEA,YAAA;EACA,WAAA;AAJN;AAMI;EACE,sBAAA;AAJN;AAQI;EACE,WAAA;AANN;AAQI;EACE,wBAAA;EACA,kBAAA;AANN;AASI;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AAPN;AAUI;EACE,wBAAA;EACA,iBAAA;AARN;AASM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;UAAA,0BAAA;EACA,uBAAA;AAPR;AAQQ;EACE,kBAAA;AANV;AAOU;EACE,cAAA;AALZ;AAQQ;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AANV;AAQQ;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;AANV;AAQQ;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;AANV;AAUM;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AARR;AASQ;EACE,mBAAA;AAPV;AAYI;EACE,iBAAA;EACA,YAAA;AAVN;AAaM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAXR;AAaM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAXR;AAaQ;EACE,eAAA;EACA,iBAAA;AAXV;AAeM;EACE,oBAAA;EACA,eAAA;AAbR;AAeQ;EACE,mBAAA;AAbV;AAiBU;EACE,mBAAA;AAfZ;AAmBI;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAjBN;AAkBM;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AAhBR;AAiBU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AAfZ;AAiBQ;EACE,gBAAA;EACA,4BAAA;EACA,gDAAA;AAfV;AAoBM;EACE,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EAEA,gBAAA;EAEA,yCAAA;EAEA,oBAAA;AArBR;AAyBM;EACE,mBAAA;EACA,6BAAA;EACA,eAAA;AAvBR;AAyBQ;EACE,aAAA;EACA,gBAAA;EACA,uCAAA;AAvBV;AAyBU;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AAvBZ;AA0BU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAxBZ;AA0BY;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;AAxBd;AAyBc;EACE,4BAAA;EACA,wBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAvBhB;AAwBgB;EACE,gCAAA;AAtBlB;AA2BY;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;AAzBd;AA4BU;EACE,YAAA;EACA,cAAA;AA1BZ;AA2BY;EACE,cAAA;EACA,cAAA;AAzBd;AA4BY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gCAAA;AA1Bd;AA2Bc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAzBhB;AA2Bc;EACE,eAAA;EACA,gBAAA;EACA,OAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AAzBhB;AA2Bc;EACE,eAAA;EACA,cAAA;AAzBhB;AA2Bc;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;AAzBhB;AA2BgB;EACE,eAAA;EACA,cAAA;AAzBlB;AA+BQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA7BV;AAkCM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAhCR;AAkCQ;EACE,eAAA;AAhCV;;AAsCE;EACE,kBAAA;EACA,kBAAA;AAnCJ;;AAsCE;EACE,QAAA;AAnCJ;;AAsCE;EACE,YAAA;EACA,eAAA;AAnCJ;;AAsCE;EACE,wBAAA;AAnCJ;;AAsCE;EACE,gBAAA;EACA,0BAAA;EAAA,kBAAA;AAnCJ;;AAsCE;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AAnCJ;AAoCI;EACE,YAAA;AAlCN;AAoCI;EACE,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAlCN;AAoCQ;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAlCV;AAmCU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAjCZ;AAsCI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AApCN;AAqCM;EACE,gBAAA;AAnCR;AAqCM;EACE,eAAA;EACA,cAAA;AAnCR;AAqCM;EACE,eAAA;AAnCR;;AAwCE;EACE,cAAA;AArCJ;AAsCI;EACE,eAAA;AApCN;AAsCI;EACE,gBAAA;AApCN;AAqCM;;;EAGE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;AAnCR;AAqCQ;;;EACE,aAAA;AAjCV;AAoCM;EACE,0BAAA;AAlCR;AAoCQ;EACE,eAAA;AAlCV;AAqCM;EACE,eAAA;AAnCR;AAsCQ;EACE,cAAA;AApCV;AAsCQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AApCV;;AA0CE;EACE,cAAA;EACA,eAAA;AAvCJ;AAwCI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAtCN;AAwCI;EACE,kBAAA;EACA,gBAAA;AAtCN;AAwCI;EACE,cAAA;AAtCN;AAuCM;EACE,gBAAA;EACA,iBAAA;AArCR;AAwCI;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;AAtCN;;AA0CE;EAUE,eAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;AAhDJ;AAoCI;EACE,eAAA;AAlCN;AAoCM;EACE,eAAA;EACA,iBAAA;AAlCR;AA2CI;EACE,UAAA;EACA,WAAA;AAzCN;AA4CI;EACE,uBAAA;AA1CN;AA6CI;EACE,kCAAA;EACA,kBAAA;AA3CN;AA8CI;EACE,qBAAA;AA5CN;;AA+CE;EACE,yBAAA;EACA,eAAA;AA5CJ;;AAgDI;EACE,eAAA;AA7CN;;AAgDE;EACE,6BAAA;AA7CJ;AA8CI;EACE,eAAA;AA5CN;AA6CM;EACE,kBAAA;AA3CR","sourcesContent":[".spinner-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.065);\n    z-index: 999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .pending {\n    background-color: var(--ion-color-warning);\n    background-size: 26.39px 24.61px;\n    // border: 1px solid black;\n  }\n  \n  .accepted {\n    // border: 2px solid black;\n    background-color: var(--ion-color-success);\n  }\n  \n  .declined {\n    // border: 2px solid  var(--ion-color-danger);\n    background-color: #ed143d;\n  }\n  \n  .resourceless {\n    background-color: #0078d4 !important;\n  }\n  \n  ion-card {\n    .image-swiper-container {\n      --swiper-pagination-color: #ed143d;\n      width: 100%;\n      overflow: hidden;\n      height: 0;\n      transition: height 0.3s ease-in-out;\n  \n      &.show {\n        height: 280px;\n      }\n  \n      swiper-slide {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100% !important;\n        // flex-shrink: 0;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n    }\n    .div-horizental {\n      width: 6px;\n      min-width: 6px;\n      // position: absolute;\n      height: 100%;\n      z-index: 10;\n    }\n    &:first-child {\n      margin: 10px 10px 20px;\n    }\n    margin: 20px 10px;\n  \n    .wrapper {\n      width: 100%;\n    }\n    ion-item::part(native) {\n      --inner-padding-end: 0px;\n      --padding-start: 0;\n    }\n  \n    .new-event-icon {\n      position: absolute;\n      color: orange;\n      top: 5px;\n      font-size: 13px;\n      right: 5px;\n      z-index: 3;\n    }\n  \n    ion-card-header {\n      padding: 10px 10px 0 0px;\n      margin-left: 10px;\n      ion-card-title {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        padding-inline-start: 10px;\n        justify-content: center;\n        ion-thumbnail {\n          margin-bottom: 5px;\n          ion-avatar {\n            margin: 0 auto;\n          }\n        }\n        ion-label {\n          font-size: 20px;\n          flex-grow: 3;\n          margin-bottom: 5px;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 1;\n          line-clamp: 1;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n        .operation-buttons-container {\n          cursor: pointer;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          gap: 10px;\n          font-size: 26px;\n          transform: translateY(-5px);\n        }\n        .operation-buttons-container ion-icon[name=\"arrow-redo-outline\"] {\n          font-size: 24px;\n          color: var(--ion-color-primary);\n          margin-left: 8px;\n        }\n      }\n  \n      ion-card-subtitle {\n        padding-bottom: 5px;\n        display: flex;\n        font-size: 11px;\n        align-items: center;\n        margin-right: 5px;\n        .location-icon {\n          margin-right: 2.5px;\n        }\n      }\n    }\n  \n    ion-card-content {\n      margin-left: 10px;\n      padding: 0px;\n      // display: flex;\n      // align-items: center;\n      .chips-container {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        padding-bottom: 8px;\n        padding-right: 8px;\n      }\n      .event-detail {\n        display: flex;\n        gap: 3px;\n        align-items: center;\n        font-size: 13px;\n        padding: 2px 5px;\n  \n        ion-icon {\n          font-size: 20px;\n          margin-right: 5px;\n        }\n      }\n  \n      ion-chip {\n        padding-inline: 10px;\n        font-size: 11px;\n  \n        ion-icon {\n          margin-right: 3.5px;\n        }\n  \n        &.organizer-chip {\n          img {\n            margin-right: 3.5px;\n          }\n        }\n      }\n    .check-in-section{\n      display: flex;\n      justify-content: end;\n      align-items: center;\n      gap:16px;\n      .check-in-button {\n        width: 158px;\n        height: 36px;\n        margin-bottom: 0;\n        margin-right: -1px;\n        text-transform: none;\n        cursor: pointer;\n          .content {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 16px;\n            color: white;\n          }\n        &::part(native) {\n          border-radius: 0;\n          border-top-left-radius: 18px;\n          box-shadow: 0px 0px 0px 8px rgba(0, 0, 0, 0.075)\n  \n        }\n        }\n      }\n      .custom-red-button {\n        --background: #ed143d;           // default\n        --background-hover: #d91237;     // hover (≈ -10% lightness)\n        --background-activated: #c01031; // pressed (≈ -20% lightness)\n        --background-focused: #d91237;   // focus\n      \n        --color: #ffffff;\n      \n        --ripple-color: rgba(255, 255, 255, 0.35);\n      \n        text-transform: none;\n      }\n  \n      \n      .description-section {\n        padding-bottom: 8px;\n        border-top: 1px solid #e0e0e0;\n        margin-top: 5px;\n  \n        .description-content {\n          max-height: 0;\n          overflow: hidden;\n          transition: max-height 0.3s ease-in-out;\n          // padding: 5px;\n          &.expanded {\n            height: auto;\n            overflow-y: auto;\n            max-height: 250px;\n          }\n  \n          .segment-header {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            position: sticky;\n            top: 0;\n            z-index: 10;\n            background: white;\n            padding: 5px;\n  \n            ion-segment {\n              --background: none;\n              display: flex;\n              justify-content: start;\n              gap: 5px;\n              flex: 1;\n              ion-segment-button {\n                --indicator-box-shadow: none;\n                --color-checked: #ed143d;\n                --border-radius: none;\n                --border-width: 0;\n                --border-color: none;\n                --border-style: none;\n                --padding-start: 5px;\n                --padding-end: 5px;\n                min-width: unset;\n                &.selectedSegment {\n                  border-bottom: 2px solid #ed143d;\n                }\n              }\n            }\n  \n            .expand-icon {\n              font-size: 20px;\n              cursor: pointer;\n              color: #b0b0b0;\n              margin-left: 10px;\n              padding: 5px;\n              border-radius: 4px;\n              transition: background-color 0.2s ease;\n            }\n          }\n          .segment-content-container {\n            padding: 5px;\n            overflow: auto;\n            ion-spinner {\n              display: block;\n              margin: 0 auto;\n            }\n            \n            .attachment-item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              padding: 5px 0;\n              border-bottom: 1px solid #e0e0e0;\n              ion-img {\n                width: 30px;\n                height: 30px;\n                border-radius: 5px;\n              }\n              .attachment-name {\n                font-size: 12px;\n                font-weight: 600;\n                flex: 1;\n                display: -webkit-box;\n                -webkit-box-orient: vertical;\n                -webkit-line-clamp: 2;\n                line-clamp: 2;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                word-break: break-word;\n              }\n              .attachment-size {\n                font-size: 12px;\n                color: #6e6e6e;\n              }\n              .download-button {\n                --padding-start: 4px;\n                --padding-end: 4px;\n                --min-height: 24px;\n                --min-width: 24px;\n                margin: 0;\n                \n                ion-icon {\n                  font-size: 16px;\n                  color: #ed143d;\n                }\n              }\n            }\n          }\n        }\n        .description-toggle {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          padding-top: 5px;\n        }\n      }\n    }\n    ion-item-options {\n      .myBookings-sliding-options {\n        margin: 1px;\n        color: black;\n        border-radius: 10px;\n        font-size: 12px;\n        padding: 0 7px;\n  \n        ion-icon {\n          font-size: 24px;\n        }\n      }\n    }\n  }\n  \n  ion-popover {\n    --max-height: 40vh;\n    --min-width: 240px;\n  }\n  \n  ion-popover.seriesPopOver::part(content) {\n    left: calc((100% - 90%) / 2);\n  }\n  \n  ion-popover.seriesPopOver {\n    --width: 90%;\n    --min-height: 0;\n  }\n  \n  ion-popover.ResponsePopOver {\n    --min-width: fit-content;\n  }\n  \n  ion-popover.info-popover::part(content) {\n    min-width: unset;\n    width: fit-content;\n  }\n  \n  ion-popover.resource-images-popover {\n    --height: unset;\n    --max-height: unset;\n    --width: 420px;\n    &::part(content) {\n      padding: 7px;\n    }\n    .image-swiper-container {\n      --swiper-pagination-color: #ed143d;\n      width: 100%;\n      overflow: hidden;\n      border-radius: 8px;\n      swiper-slide {\n        .image-container {\n          width: 100%;\n          height: 280px;\n          overflow: hidden;\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n        }\n      }\n    }\n    .resource-images-info {\n      padding-top: 5px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      ion-label {\n        font-weight: 600;\n      }\n      ion-icon {\n        font-size: 16px;\n        color: #ed143d;\n      }\n      ion-chip {\n        cursor: default;\n      }\n    }\n  }\n  \n  ion-popover.display-name {\n    --width: 275px;\n    ion-icon {\n      font-size: 16px;\n    }\n    ion-label {\n      margin: 5px 10px;\n      .displayName,\n      .address,\n      .emailAddress {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        margin: 7px 0;\n        word-break: break-word;\n  \n        div {\n          display: flex;\n        }\n      }\n      .address {\n        font-size: 12px !important;\n        // margin-left: -2px;\n        ion-icon {\n          font-size: 16px;\n        }\n      }\n      .displayName {\n        font-size: 15px;\n      }\n      .emailAddress {\n        ion-icon {\n          color: #6e6e6e;\n        }\n        small {\n          color: #6e6e6e;\n          font-size: 12px;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n  \n  ion-popover.extend-meeting-popover {\n    --width: 325px;\n    --height: unset;\n    .extend-meeting-container {\n      padding: 8px;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n    }\n    .title-label {\n      text-align: center;\n      font-weight: 600;\n    }\n    .extend-meeting-options {\n      margin: 0 auto;\n      ion-chip {\n        padding: 4px 8px;\n        min-height: unset;\n      }\n    }\n    .extend-meeting-error-note {\n      text-align: center;\n      font-size: 12px;\n      color: #ed143d !important;\n    }\n  }\n  \n  .container {\n    ion-item {\n      font-size: 12px;\n  \n      ion-icon {\n        font-size: 30px;\n        margin-right: 5px;\n      }\n    }\n  \n    font-size: 14px;\n    max-height: 250px !important;\n    margin: 8px 5px 8px 13px;\n    overflow-y: scroll;\n  \n    &::-webkit-scrollbar {\n      width: 5px;\n      height: 5px;\n    }\n  \n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background: var(--ion-color-light);\n      border-radius: 2px;\n    }\n  \n    .inner-scroll {\n      scrollbar-width: thin;\n    }\n  }\n  .tip-container {\n    margin: 8px 13px 8px 13px;\n    font-size: 14px;\n  }\n  \n  .user-response-container {\n    ion-icon {\n      font-size: 30px;\n    }\n  }\n  ion-popover.forward-options {\n    --min-width: unset !important;\n    ion-item {\n      font-size: 14px;\n      ion-icon {\n        margin-right: 10px;\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
